import React from 'react'
import './FilterBar.css'

interface FilterBarProps {
  activeFilter: string
  filterCounts: {
    all: number
    critical: number
    warning: number
    info: number
    dismissed: number
  }
  onFilterClick: (filter: any) => void
  searchTerm: string
  onSearchChange: (term: string) => void
}

export const FilterBar: React.FC<FilterBarProps> = ({
  activeFilter,
  filterCounts,
  onFilterClick,
  searchTerm,
  onSearchChange
}) => {
  const filters = [
    { id: 'all', label: 'All', count: filterCounts.all },
    { id: 'critical', label: 'Critical', count: filterCounts.critical, color: 'critical' },
    { id: 'warning', label: 'Warning', count: filterCounts.warning, color: 'warning' },
    { id: 'info', label: 'Info', count: filterCounts.info, color: 'info' },
    { id: 'dismissed', label: 'Dismissed', count: filterCounts.dismissed, color: 'dismissed' }
  ]

  return (
    <div className="filter-bar">
      <div className="filter-pills">
        {filters.map(filter => (
          <button
            key={filter.id}
            className={`filter-pill ${filter.color || ''} ${activeFilter === filter.id ? 'active' : ''}`}
            onClick={() => onFilterClick(filter.id)}
            aria-pressed={activeFilter === filter.id}
          >
            <span className="filter-label">{filter.label}</span>
            <span className="filter-count">{filter.count}</span>
            {filter.id === 'critical' && filter.count > 0 && (
              <span className="pulse-indicator" aria-hidden="true" />
            )}
          </button>
        ))}
      </div>
      
      <div className="filter-search">
        <input
          type="search"
          className="search-input"
          placeholder="Search suggestions..."
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          aria-label="Search suggestions"
        />
        {searchTerm && (
          <button
            className="search-clear"
            onClick={() => onSearchChange('')}
            aria-label="Clear search"
          >
            ×
          </button>
        )}
      </div>
    </div>
  )
}

export default FilterBar